import { toast } from "react-toastify";

export const baseURL = process.env.REACT_APP_API_BASE_URL;
// export const baseURL = 'http://localhost:9008/'

export const imageURL = baseURL + "uploads/";
export const apiUrl = baseURL + "api";

export const api = apiUrl;

export const saveRecords = async (payload, endpoint) => {
  try {
    // Fetch token from localStorage
    const response = await fetch(apiUrl + endpoint, {
      method: "POST", // Use POST method
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload), // Stringify the payload
    });
    return response.json();
  } catch (error) {
    console.error("fetahcData Error fetching data:", error);
    throw error; // Re-throw the error for further handling if needed
  }
};

export const getRecords = async (payload, endpoint) => {
  try {
    // Fetch token from localStorage
    const response = await fetch(apiUrl + endpoint, {
      method: "POST", // Use POST method
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload), // Stringify the payload
    });
    return response.json();
  } catch (error) {
    console.error("fetahcData Error fetching data:", error);
    throw error; // Re-throw the error for further handling if needed
  }
};

/**
 * Soft deletes a master record.
 * The API blocks the delete (code 0) when the record is already used somewhere
 * else and returns a message naming those modules.
 */
export const deleteRecord = async (payload, endpoint = "/deleteRecord") => {
  try {
    const response = await fetch(apiUrl + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    return response.json();
  } catch (error) {
    console.error("deleteRecord Error:", error);
    throw error;
  }
};

export const dropdownData = async (
  responseData,
  fieldName,
  selectedFieldName,
  isOtherDependentOnThis,
) => {
  try {
    if (!responseData && responseData.length == 0) {
      return []; // Return empty array if no data is available
    }
    var options = [];
    responseData.forEach((element) => {
      options.push({
        label: element[fieldName],
        value: element.id,
        fieldName: selectedFieldName,
        isOtherDependentOnThis,
        data: responseData,
      });
    });
    const dropdownResponseData = [{ options: options }];
    return dropdownResponseData;
  } catch (error) {
    console.error("Error fetching data:", error);
    // Handle errors appropriately (throw error, display error message, etc.)
    throw error; // Re-throw the error for further handling if needed
  }
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const formatNumber = (value) => {
  if (value === null || value === undefined || value === "") return "0";
  const num = Number(value);
  if (isNaN(num)) return "0";
  const formatted = num.toFixed(2).toString();
  return formatted.replace(/\.00$/, "");
};

export const uploadExelFile = async (file, endpoint, options = {}) => {
  try {
    const formData = new FormData();

    if (options.useSchemaPayload) {
      const schema = localStorage.getItem("schema");
      const userDetails = JSON.parse(localStorage.getItem("authUser"));
      if (!schema) {
        throw new Error("Schema not found in localStorage");
      }
      if (!userDetails.id) {
        throw new Error("User ID not found in localStorage");
      }
      formData.append("schema_name", schema);
      formData.append("created_by", userDetails.id);
      formData.append("file", file);
    } else {
      formData.append("file", file);
    }

    // Add any additional data
    if (options.additionalData) {
      Object.entries(options.additionalData).forEach(([key, value]) => {
        formData.append(key, value);
      });
    }

    const apiUrlToUse = apiUrl;
    const fullUrl = apiUrlToUse + endpoint;

    const response = await fetch(fullUrl, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      let errorMessage = `Server error: ${response.status} ${response.statusText}`;

      try {
        const errorData = await response.json();
        errorMessage = errorData.message || errorData.error || errorMessage;
      } catch (e) {
        // If response is not JSON, try to get text
        try {
          const errorText = await response.text();
          if (errorText) errorMessage = errorText;
        } catch (textError) {
          // Ignore if we can't get text either
        }
      }

      throw new Error(errorMessage);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Upload failed:", error);
    throw error;
  }
};

export const downloadFile = async (endpoint, options = {}) => {
  try {
    const { fileName = "download.xlsx" } = options;

    // Determine which API URL to use
    const apiUrlToUse = apiUrl;

    // Sending GET request to backend
    const response = await fetch(apiUrlToUse + endpoint, {
      method: "GET",
      headers: {
        // Add any required headers here
      },
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    // Get the blob from the response
    const blob = await response.blob();

    // Create a download link and trigger the download
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    // Clean up
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);

    return { success: true };
  } catch (error) {
    console.error("Error downloading file:", error);
    throw error; // Propagate the error for handling
  }
};

/* ------------------------------------------------------------------ *
 * Smart Import (master screens)
 *
 * The template is fingerprinted server side, so the same file that is
 * downloaded here is the only file the upload endpoint will accept.
 * ------------------------------------------------------------------ */

const importSchema = () => localStorage.getItem("schema") || "";

/** Columns / mandatory flags shown inside the import modal. */
export const getImportConfig = async (moduleKey) => {
  const response = await fetch(
    `${apiUrl}/import/master/config/${encodeURIComponent(moduleKey)}`
  );
  return response.json();
};

/** Downloads the .xlsx template for a master and saves it to the browser. */
export const downloadImportTemplate = async (moduleKey, fileName) => {
  const response = await fetch(
    `${apiUrl}/import/master/template/${encodeURIComponent(
      moduleKey
    )}?schema=${encodeURIComponent(importSchema())}`
  );

  if (!response.ok) {
    throw new Error(`Unable to download template (${response.status})`);
  }

  // the endpoint answers with JSON only when it could not build the workbook
  const contentType = response.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    const error = await response.json();
    throw new Error(error?.message || "Unable to download template");
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName || `${moduleKey}-import-template.xlsx`;
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);

  return { success: true };
};

/** Uploads the filled template back and returns the import summary. */
export const importMasterFile = async (moduleKey, file) => {
  const user = JSON.parse(localStorage.getItem("authUser") || "{}");

  const formData = new FormData();
  formData.append("module", moduleKey);
  formData.append("schema", importSchema());
  formData.append("created_by", user?.id || "");
  formData.append("file", file);

  const response = await fetch(`${apiUrl}/import/master/upload`, {
    method: "POST",
    body: formData,
  });

  return response.json();
};
